<template>
  <v-container>
    <v-form ref="form">
      <v-row dense>
        <v-col cols="12">
          <password-field
            v-model="crud.old_password"
            label="Old Password"
            outlined
            autocomplete="new-password"
            dense
            :success-messages="
              crud.old_password && passwordChanged ? 'Password successfully changed' : ''
            "
            :error-messages="wrongCred ? 'Incorrect Password' : ''"
            :rules="[(v) => !!v || 'Old Password required.']"
            @input="passwordChanged = false"
          />
        </v-col>
        <v-col cols="12">
          <password-field
            v-model="crud.new_password1"
            label="New Password"
            outlined
            dense
            autocomplete="new-password"
            :success-messages="correctPassword"
            hint="Must contain at least one numeric digit and one lowercase letter"
            :rules="[(v) => !!v || 'Password required.', rules.min, rules.num, rules.letter]"
          />
        </v-col>
        <v-col cols="12">
          <password-field
            v-model="crud.new_password2"
            label="Repeat your new password"
            outlined
            dense
            autocomplete="new-password"
            :success-messages="goodPassword2"
            :rules="[(v) => !!v || 'Confirm Password required.', rules.identical]"
          />
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn
            class="text-capitalize"
            depressed
            outlined
            color="#FF347C"
            @click="onClick"
            :loading="loading"
            >Confirm</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import { changePassword } from "@/api/api";
import PasswordField from "./PasswordField.vue";

export default {
  components: { PasswordField },
  data() {
    return {
      rules: {
        identical: () => {
          if (this.crud.new_password1 !== this.crud.new_password2) {
            return "Passwords must match";
          }
          return true;
        },
        min: (v) => {
          return v.length > 7 || "Password too short";
        },
        num: (v) => {
          var number = /[0-9]/;
          return number.test(v) || "Password must contain numbers";
        },
        letter: (v) => {
          var letter = /[a-zA-Z]/;
          return letter.test(v) || "Password must contain letters";
        },
      },
      crud: {
        new_password1: "",
        new_password2: "",
        old_password: "",
      },
      loading: false,
      wrongCred: false,
      passwordChanged: false,
    };
  },
  computed: {
    small() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    correctPassword() {
      var number = /[0-9]/;
      var letter = /[a-zA-Z]/;
      if (
        this.crud.new_password1 &&
        number.test(this.crud.new_password1) &&
        letter.test(this.crud.new_password1) &&
        this.crud.new_password1.length > 7
      )
        return "Good Password";
      return "";
    },
    goodPassword2() {
      if (this.crud.new_password2 && this.crud.new_password1 === this.crud.new_password2) {
        return "Passwords match";
      }
      return "";
    },
  },
  methods: {
    async onClick() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      const response = await changePassword(this.crud);
      if (response) {
        this.wrongCred = false;
        this.passwordChanged = true;
      } else this.wrongCred = true;
      this.loading = false;
    },
  },
};
</script>
